import React, {useEffect, useState} from 'react';
import {FormattedMessage} from "react-intl";
import messages from "./messages";
import MyDateTime from "../../../components/InputField/MyDateTime";
import AsyncSelect from "react-select/async";
import {partial} from "underscore";
import debounce from "debounce-promise";

const RetakeSearch = ({
                        search_params_update,
                        search_params,
                        trigger_update,
                        trigger_download
                      }) => {


  const paidOptions = [
    {label: 'Yes', value: true},
    {label: 'No', value: false}
  ];

  const foundbyOptions = [
    {label: 'customer', value: 'customer'},
    {label: 'internally', value: 'internally'},
    {label: 'supplier', value: 'supplier'}
  ];

  const [coordinator, coordinatorUpdate] = useState(
    search_params['coordinator'])
  const [supplier, supplierUpdate] = useState(search_params['supplier'])
  const [language, languageUpdate] = useState(search_params['language'])
  const [customer, customerUpdate] = useState(search_params['customer'])
  const [retake, retakeUpdate] = useState(search_params['retake'])
  const [errorLevel, errorLevelUpdate] = useState(search_params['errorLevel'])
  const [to, toUpdate] = useState(search_params['to'])
  const [from, fromUpdate] = useState(search_params['from'])
  const [paid, paidUpdate] = useState(paidOptions.filter((row) => row.value === search_params['paid']));
  const [foundby, foundbyUpdate] = useState(paidOptions.filter((row) => row.value === search_params['foundby']));

  const buttonClass = "cursor-pointer inline-block border-2 uppercase py-1 px-2 mx-2 font-medium text-center text-sm focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-darker transition duration-200 ease-in-out shadow-sm rounded-sm space-x-2 bg-primary border-primary text-white hover:bg-white hover:text-primary"

  useEffect(() => {
    search_params_update({
      ...search_params,
      coordinator: coordinator === null ? null : coordinator.value,
      supplier: supplier === null ? null : supplier.value,
      language: language === null ? null : language.value,
      customer: customer === null ? null : customer.value,
      retake: retake === null ? null : retake.value,
      to: to === null ? null : to,
      from: from === null ? null : from,
      paid: paid === null ? null : paid.value,
      foundby: foundby === null ? null : foundby.value,
      errorLevel: errorLevel === null ? null : errorLevel.value
    })
  }, [coordinator, supplier, language, customer, retake, to, from, paid, foundby, errorLevel])


  const filter = async (url, value, label, selected, update, filterServerSide, transformer, input) => {

    const filterInput = (entry) => entry.label.toLowerCase().includes(input.toLowerCase())

    const transform_to_stander_format = (result) => (result.hasOwnProperty('data') ? result.data : result);
    const useTransformer = (result) => (transformer ? transformer(result) : result);
    const convert_to_label_value_pair = (result) => result.map((row) => ({
      value: row[value],
      label: row[label]
    }));

    const update_selected_value_and_filter_input = (result) => {
      const select = result.filter((item) => (selected === item.value));
      if (select.length > 0) {
        update(select[0]);
      }
      return result.filter(filterInput);
    };

    if (filterServerSide) {
      url += input
    }

    return fetch(url).then(res => res.json()
    ).then(transform_to_stander_format).then(useTransformer)
      .then(convert_to_label_value_pair).then(update_selected_value_and_filter_input);
  };


  const promiseOptions = (url, value, label, selected, update, filterServerSide, transfomer, input) => {
    return Promise.resolve(filter(url, value, label, selected, update, filterServerSide, transfomer, input));

  };

  const convertErrorLevelsToStander = (results) => {
    return results.map((row) => {
      if (row.children) {
        return [row, ...row.children.map((child) => {
          child.name = "\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0" + child.name;
          return child
        })];
      }
      return row;
    }).flat();
  };

  const coordinatorsOptions = partial(promiseOptions, '/rest/v2/coordinators', 'uid', 'name', coordinator, coordinatorUpdate, false, false);

  const supplierOptions = partial(promiseOptions, '/rest/v2/supplier?pageSize=200&search[identifier]=', 'uid', 'userid', supplier, supplierUpdate, true, false);
  const companyOptions = partial(promiseOptions, '/rest/v2/customer/list?pageSize=200&search[name]=', 'uid', 'name', customer, customerUpdate, true, false);

  const languageOptions = partial(promiseOptions, '/rest/v2/language', 'uid', 'name', language, languageUpdate, false, false);
  const retakeOptions = partial(promiseOptions, '/rest/v2/taskretakereason?search[deleted]=0&pageSize=100', 'uid', 'name', retake, retakeUpdate, false, false);

  const errorLevelOptions = partial(promiseOptions, '/rest/v2/incident/error-levels', 'id', 'name', errorLevel, errorLevelUpdate, false, convertErrorLevelsToStander);

  function getAsyncSelect(title, options, update, selected, useDefaultOptions) {
    return <div className="flex-1 flex-col space-x-2">
      <div className="text-gray-500 mb-2 ml-3 ">{title}</div>
      <AsyncSelect cacheOptions defaultOptions={useDefaultOptions} loadOptions={debounce(options, 250)}
                   onChange={update}
                   isClearable value={selected}
      ></AsyncSelect>
    </div>;
  }

  return (
    <form
      className="flex bg-secondary-lighter py-2 mx-2 items-center">
      {getAsyncSelect('Coordinator:', coordinatorsOptions, coordinatorUpdate, coordinator, false)}
      {getAsyncSelect('Supplier:', supplierOptions, supplierUpdate, supplier, false)}
      {getAsyncSelect('Company:', companyOptions, customerUpdate, customer, false)}
      {getAsyncSelect('Retake reason:', retakeOptions, retakeUpdate, retake, true)}
      {getAsyncSelect('Task Type:', errorLevelOptions, errorLevelUpdate, errorLevel, true)}
      {getAsyncSelect('Language:', languageOptions, languageUpdate, language, false)}
      <div className="flex-1 flex-col space-x-2">
        <div className="text-gray-500 mb-2 ml-3 ">Paid:</div>
        <AsyncSelect cacheOptions defaultOptions={paidOptions} onChange={paidUpdate} isClearable value={paid}
        ></AsyncSelect>
      </div>
      <div className="flex-1 flex-col space-x-2">
        <div className="text-gray-500 mb-2 ml-3 ">Found by</div>
        <AsyncSelect cacheOptions defaultOptions={foundbyOptions} onChange={foundbyUpdate} isClearable value={foundby}
        ></AsyncSelect>
      </div>

      <MyDateTime name="from" id="from" value={from}
                  update={fromUpdate}
                  label_string="From Date:"/>
      <MyDateTime name="to" id="to" value={to}
                  update={toUpdate}
                  label_string="To Date:"/>
      <div className="h-2">
        <button className={buttonClass} type="button"
                onClick={trigger_update}>
          <FormattedMessage  {...messages.get_report}/></button>
        <button className={buttonClass} type="button"
                onClick={trigger_download}>
          <FormattedMessage {...messages.download_csv}/></button>
      </div>
    </form>

  );
};

export default RetakeSearch;
